import React from 'react';
import OverlayWindow, { WindowSize } from 'Components/OverlayWindow';
import Button from 'Components/Buttons/Button';
import { QBOIcon } from 'assets/icons';

interface QuickbooksModalProps {
  onSelect: (suggestion: string) => void;
  onClose: () => void;
}

const QB_SUGGESTIONS = ['invoice?', 'balance sheet?', 'profit and loss?'];

const QuickbooksModal: React.FC<QuickbooksModalProps> = ({
  onSelect,
  onClose,
}) => {
  return (
    <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
      <OverlayWindow
        title={
          <div className="flex items-center gap-2">
            <QBOIcon className="w-5 h-5" />
            <span>QuickBooks</span>
          </div>
        }
        onClose={onClose}
        size={WindowSize.sm}
        body={
          <div className="flex flex-col gap-2 p-2">
            {QB_SUGGESTIONS.map((opt) => (
              <Button
                key={opt}
                theme="green-outline"
                onClick={() => {
                  onSelect(opt);
                  onClose();
                }}
              >
                {opt}
              </Button>
            ))}
          </div>
        }
      />
    </div>
  );
};

export default QuickbooksModal;
export { QB_SUGGESTIONS };
